module.exports = __webpack_public_path__ + "media/images/logo-7b9d2ebb4b139f0aa1a05ffbdcf061ef.png";